module.exports = __webpack_public_path__ + "img/board_bg_ico.0488c7d5.svg";